/* Memorial · buscador guiado: entiende tipo, color, presupuesto y urgencia; también busca por nombre de producto o SKU; muestra opciones y los más pedidos */
(function () {
  'use strict';

  var COLECCION = 'todos-los-arreglos';
  var RAPIDA = 'envio-en-3hrs';
  var FRASES = [
    'Busco una corona roja para mañana, hasta S/ 300',
    'Flores blancas para mi tía, presupuesto S/ 150',
    'Un manto de rosas rojas para hoy',
    'Lágrima azul hasta 250 soles',
    'Arreglo blanco con liliums hasta 200 soles'
  ];
  var EJEMPLOS = [
    'corona roja para mañana',
    'flores blancas hasta S/ 150',
    'manto de rosas rojas',
    'lágrima azul hasta 250 soles',
    'entrega hoy'
  ];

  var COLORES = {
    roja: { nombre: 'rojo', re: /\b(rojo|roja|rojos|rojas|carmesi|escarlata|colorado|colorada)\b/ },
    blanca: { nombre: 'blanco', re: /\b(blanco|blanca|blancos|blancas)\b/ },
    rosada: { nombre: 'rosado', re: /\b(rosado|rosada|rosados|rosadas)\b/ },
    amarilla: { nombre: 'amarillo', re: /\b(amarillo|amarilla|amarillos|amarillas)\b/ },
    azul: { nombre: 'azul', re: /\b(azul|azules)\b/ },
    lila: { nombre: 'lila', re: /\b(lila|lilas|morado|morada|morados|moradas|violeta|violetas|purpura)\b/ },
    fucsia: { nombre: 'fucsia', re: /\b(fucsia|fucsias)\b/ }
  };

  var TIPOS = [
    { id: 'cruz', re: /\b(cruz|cruces)\b/, cats: ['cruz'], nombre: 'Cruz' },
    { id: 'corazon', re: /\b(corazon|corazones)\b/, cats: ['corazon'], nombre: 'Corona de corazón' },
    { id: 'piso', re: /\b(de piso|piso)\b/, cats: ['piso'], nombre: 'Lágrima de piso' },
    { id: 'pie', re: /\bde pie\b/, cats: ['pie'], nombre: 'Lágrima de pie' },
    { id: 'lagrima', re: /\blagrimas?\b/, cats: ['piso', 'pie'], nombre: 'Lágrima' },
    { id: 'corona', re: /\b(corona|coronas)\b/, cats: ['corona', 'corazon'], nombre: 'Corona' },
    { id: 'manto', re: /\b(manto|mantos)\b/, cats: ['manto'], nombre: 'Manto' },
    { id: 'arreglo', re: /\b(arreglo|arreglos|jarron|jarrones|canasta|canastas|cesto|cestos|ramo|ramos)\b/, cats: ['arreglo'], nombre: 'Arreglo' }
  ];

  var datos = null, rapidos = null, cargando = null, campo = null, bloque = null;
  var descartados = {}, temporizador = null, mostrarTodos = false, ultimoEvento = '';

  function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function soles(n) { return 'S/ ' + Math.round(n); }
  function el(tag, clase, texto) { var e = document.createElement(tag); if (clase) e.className = clase; if (texto != null) e.textContent = texto; return e; }

  function categoria(h) {
    var r = [['cruz', 'cruz'], ['corona-de-corazon', 'corazon'], ['corona', 'corona'], ['lagrima-de-piso', 'piso'], ['lagrima', 'pie'], ['manto', 'manto']];
    for (var i = 0; i < r.length; i++) if (h.indexOf(r[i][0]) === 0) return r[i][1];
    return 'arreglo';
  }

  /* ---------- interpretación de la frase ---------- */
  function interpretar(texto) {
    var t = norm(texto);
    var f = { tipos: [], cats: [], colores: [], min: null, max: null, aprox: false, urgente: false };

    var vistos = {};
    TIPOS.forEach(function (tp) { if (tp.re.test(t)) vistos[tp.id] = true; });
    if (vistos.piso || vistos.pie) delete vistos.lagrima;
    if (vistos.corazon && /corona/.test(t)) delete vistos.corona;
    TIPOS.forEach(function (tp) {
      if (vistos[tp.id] && !descartados['tipo:' + tp.id]) {
        f.tipos.push(tp);
        tp.cats.forEach(function (c) { if (f.cats.indexOf(c) < 0) f.cats.push(c); });
      }
    });

    Object.keys(COLORES).forEach(function (k) {
      if (COLORES[k].re.test(t) && !descartados['color:' + k]) f.colores.push(k);
    });

    if (!descartados.urgente && /\b(hoy|ahora|urgente|urgencia|inmediato|inmediata|ya mismo|3 horas|tres horas|3 hrs|3h)\b/.test(t)) f.urgente = true;

    if (!descartados.presupuesto) {
      var m = t.match(/(?:entre|de|desde)\s*(?:s\/\.?\s*)?(\d{3,4})(?:[.,]\d+)?\s*(?:soles?\s*)?(?:y|a|hasta|-)\s*(?:s\/\.?\s*)?(\d{3,4})/);
      if (m) {
        var a = parseFloat(m[1]), b = parseFloat(m[2]);
        f.min = Math.min(a, b); f.max = Math.max(a, b);
      } else {
        var n = t.match(/(?:s\/\.?\s*)?(\d{3,4})(?:[.,]\d+)?/);
        if (n) {
          var v = parseFloat(n[1]);
          if (v >= 100 && v <= 2000) {
            if (/(alrededor de|aproximadamente|aprox|mas o menos|cerca de|unos)/.test(t)) { f.min = Math.round(v * 0.85); f.max = Math.round(v * 1.15); f.aprox = v; }
            else if (/(mas de|a partir de|minimo|mayor a|desde)/.test(t)) f.min = v;
            else f.max = v;
          }
        }
      }
    }
    f.entendido = f.tipos.length > 0 || f.colores.length > 0 || f.max != null || f.min != null || f.urgente;
    return f;
  }

  function etiquetas(f) {
    var c = [];
    f.tipos.forEach(function (tp) { c.push({ k: 'tipo:' + tp.id, t: tp.nombre }); });
    f.colores.forEach(function (k) { c.push({ k: 'color:' + k, t: 'Color ' + COLORES[k].nombre }); });
    if (f.aprox) c.push({ k: 'presupuesto', t: 'Alrededor de ' + soles(f.aprox) });
    else if (f.min != null && f.max != null) c.push({ k: 'presupuesto', t: 'De ' + soles(f.min) + ' a ' + soles(f.max) });
    else if (f.max != null) c.push({ k: 'presupuesto', t: 'Hasta ' + soles(f.max) });
    else if (f.min != null) c.push({ k: 'presupuesto', t: 'Desde ' + soles(f.min) });
    if (f.urgente) c.push({ k: 'urgente', t: 'Entrega en 3 horas' });
    return c;
  }

  function filtrar(f) {
    var lista = datos.filter(function (p) {
      if (f.cats.length && f.cats.indexOf(p.cat) < 0) return false;
      if (f.colores.length && !f.colores.some(function (c) { return p.colores.indexOf(c) >= 0; })) return false;
      if (f.min != null && p.precio < f.min) return false;
      if (f.max != null && p.precio > f.max) return false;
      if (f.urgente && rapidos && !rapidos[p.handle]) return false;
      return true;
    });
    if (f.max != null && f.min == null) lista.sort(function (a, b) { return b.precio - a.precio || a.orden - b.orden; });
    else if (f.min != null) lista.sort(function (a, b) { return a.precio - b.precio || a.orden - b.orden; });
    return lista;
  }

  /* ---------- búsqueda literal por nombre de producto o SKU ---------- */
  function buscarLiteral(qNorm) {
    if (!datos || !qNorm || qNorm.length < 2) return [];
    var porSku = [], porNombre = [], vistos = {};
    datos.forEach(function (p) {
      if (p.sku && p.sku.length && p.sku.indexOf(qNorm) === 0) { porSku.push(p); vistos[p.handle] = true; }
    });
    if (qNorm.length >= 3) {
      datos.forEach(function (p) {
        if (!vistos[p.handle] && norm(p.title).indexOf(qNorm) !== -1) { porNombre.push(p); vistos[p.handle] = true; }
      });
    }
    porSku.sort(function (a, b) { return a.sku.localeCompare(b.sku); });
    porNombre.sort(function (a, b) { return a.orden - b.orden; });
    return porSku.concat(porNombre);
  }

  var FEMENINO = { rojo: 'roja', blanco: 'blanca', rosado: 'rosada', amarillo: 'amarilla' };
  function descripcion(f) {
    var fem = f.tipos.length > 0 && f.tipos.every(function (t) { return ['corona', 'corazon', 'lagrima', 'piso', 'pie', 'cruz'].indexOf(t.id) >= 0; });
    var partes = [];
    if (f.tipos.length) partes.push(f.tipos.map(function (t) { return t.nombre.toLowerCase(); }).join(' o '));
    else partes.push('arreglos');
    if (f.colores.length) partes.push(f.colores.map(function (c) { var n = COLORES[c].nombre; return fem && FEMENINO[n] ? FEMENINO[n] : n; }).join(' o '));
    return partes.join(' ');
  }

  /* ---------- carga de datos ---------- */
  function precio(v) { return parseFloat(v.price); }
  function cargar() {
    if (datos) return Promise.resolve();
    if (cargando) return cargando;
    var u1 = '/collections/' + COLECCION + '/products.json?limit=250';
    var u2 = '/collections/' + RAPIDA + '/products.json?limit=250';
    cargando = Promise.all([
      fetch(u1, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; }),
      fetch(u2, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; })
    ]).then(function (res) {
      datos = (res[0].products || []).filter(function (p) { return p.variants && p.variants.length; }).map(function (p, i) {
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        var t = norm(p.title + ' ' + tags.join(' '));
        var colores = Object.keys(COLORES).filter(function (k) { return COLORES[k].re.test(t); });
        return { handle: p.handle, title: p.title, precio: precio(p.variants[0]), img: p.images && p.images[0] ? p.images[0].src : '', cat: categoria(p.handle), colores: colores, orden: i, sku: norm((p.variants[0] && p.variants[0].sku) || '').replace(/\s+/g, '') };
      });
      rapidos = {};
      (res[1].products || []).forEach(function (p) { rapidos[p.handle] = true; });
    });
    return cargando;
  }

  /* ---------- pintado ---------- */
  function estilos() {
    if (document.getElementById('mm-busca-css')) return;
    var s = document.createElement('style'); s.id = 'mm-busca-css';
    s.textContent =
      '.mm-busca{margin:14px auto 6px;max-width:960px;padding:16px;border-radius:14px;background:#F8F6EF;border:1px solid rgba(23,43,33,.12);color:#172B21;text-align:left;max-height:64vh;overflow-y:auto}' +
      '.mm-busca *{box-sizing:border-box}' +
      '.mm-busca__guia{margin:0 0 10px;font-size:14px;line-height:1.4;color:#33443a}' +
      '.mm-busca__titulo{margin:14px 0 8px;font-size:15px;font-weight:600}' +
      '.mm-busca__chips{display:flex;flex-wrap:wrap;gap:8px;align-items:center}' +
      '.mm-busca__chip{padding:7px 12px;border-radius:999px;border:1px solid rgba(23,43,33,.25);background:#fff;color:#172B21;font-size:13px;line-height:1.2;cursor:pointer}' +
      '.mm-busca__chip:hover{border-color:#29371C;background:#eef0e6}' +
      '.mm-busca__ent{background:#29371C;border-color:#29371C;color:#E5E1D1;display:inline-flex;gap:6px;align-items:center}' +
      '.mm-busca__ent b{font-weight:700;cursor:pointer;padding-left:2px}' +
      '.mm-busca__estado{margin:12px 0 4px;font-size:14px;font-weight:600}' +
      '.mm-busca__aviso{margin:6px 0 10px;font-size:13px;color:#4a4a4a;line-height:1.4}' +
      '.mm-busca__lista{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-top:8px}' +
      '.mm-busca__card{display:flex;flex-direction:column;gap:5px;padding:8px;border-radius:10px;background:#fff;border:1px solid rgba(23,43,33,.12);text-decoration:none;color:inherit}' +
      '.mm-busca__card:hover{border-color:#29371C}' +
      '.mm-busca__img{width:100%;aspect-ratio:4/5;object-fit:cover;border-radius:6px;background:#eee}' +
      '.mm-busca__nombre{font-size:12px;line-height:1.3;color:#172B21;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:31px}' +
      '.mm-busca__precio{font-size:14px;font-weight:700;color:#29371C}' +
      '.mm-busca__mas{display:block;margin:12px auto 0;padding:9px 18px;border-radius:8px;border:1px solid #172B21;background:transparent;color:#172B21;font-size:13px;cursor:pointer}' +
      '.mm-busca__nota{margin:12px 0 0;font-size:12px;color:#6b6b6b;text-align:center}' +
      '.mm-busca--activa~.m-search-popup__result,.mm-busca--activa+.m-search-popup__result{display:none!important}' +
      '@media (max-width:767px){.mm-busca{margin:10px 0 4px;padding:12px;max-height:58vh}.mm-busca__lista{grid-template-columns:repeat(2,minmax(0,1fr))}}';
    document.head.appendChild(s);
  }

  function tarjeta(p) {
    var a = el('a', 'mm-busca__card'); a.href = '/products/' + p.handle;
    if (p.img) { var im = el('img', 'mm-busca__img'); im.loading = 'lazy'; im.alt = p.title; im.src = p.img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2'); a.appendChild(im); }
    a.appendChild(el('span', 'mm-busca__nombre', p.title));
    a.appendChild(el('span', 'mm-busca__precio', soles(p.precio)));
    a.addEventListener('click', function () { evento('mm_busqueda_clic', { producto: p.handle }); });
    return a;
  }

  function evento(nombre, datosEv) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre }; for (var k in datosEv) o[k] = datosEv[k];
    window.dataLayer.push(o);
  }

  function limpiar() { while (bloque.firstChild) bloque.removeChild(bloque.firstChild); }

  // Pinta el bloque de resultados (grilla, "ver más" y nota), lo usan tanto la búsqueda guiada como la literal
  function mostrarResultados(usados) {
    var lim = mostrarTodos ? usados.length : 8;
    var l = el('div', 'mm-busca__lista');
    usados.slice(0, lim).forEach(function (p) { l.appendChild(tarjeta(p)); });
    bloque.appendChild(l);
    if (usados.length > lim) {
      var mas = el('button', 'mm-busca__mas', 'Ver ' + (usados.length - lim) + ' más'); mas.type = 'button';
      mas.addEventListener('click', function () { mostrarTodos = true; pintar(); });
      bloque.appendChild(mas);
    }
    bloque.appendChild(el('p', 'mm-busca__nota', 'El precio es del arreglo. El envío se suma según tu zona (desde S/ 25).'));
  }

  function pintarVacio() {
    bloque.classList.remove('mm-busca--activa');
    limpiar();
    bloque.appendChild(el('p', 'mm-busca__guia', 'Cuéntanos qué buscas: el tipo de arreglo, el color, tu presupuesto, o el nombre o código del producto. Por ejemplo:'));
    var ch = el('div', 'mm-busca__chips');
    EJEMPLOS.forEach(function (ej) {
      var b = el('button', 'mm-busca__chip', ej); b.type = 'button';
      b.addEventListener('click', function () { campo.value = ej; campo.dispatchEvent(new Event('input', { bubbles: true })); campo.focus(); });
      ch.appendChild(b);
    });
    bloque.appendChild(ch);
    if (datos && datos.length) {
      bloque.appendChild(el('p', 'mm-busca__titulo', 'Los más pedidos'));
      var l = el('div', 'mm-busca__lista');
      datos.slice(0, 8).forEach(function (p) { l.appendChild(tarjeta(p)); });
      bloque.appendChild(l);
    } else if (cargando) {
      bloque.appendChild(el('p', 'mm-busca__aviso', 'Cargando opciones…'));
    }
  }

  function pintar() {
    var texto = campo.value.trim();
    if (!texto) { descartados = {}; pintarVacio(); return; }
    if (!datos) { pintarVacio(); return; }

    // Primero: coincidencia literal por nombre de producto o SKU (evita, por ejemplo, que un código como "MEM300" se lea como un presupuesto)
    var qNorm = norm(texto);
    var literales = buscarLiteral(qNorm);
    if (literales.length) {
      bloque.classList.add('mm-busca--activa');
      limpiar();
      bloque.appendChild(el('p', 'mm-busca__estado', literales.length + (literales.length === 1 ? ' resultado para "' : ' resultados para "') + texto + '"'));
      mostrarResultados(literales);
      var claveLit = 'texto:' + qNorm + '|' + literales.length;
      if (claveLit !== ultimoEvento) { ultimoEvento = claveLit; evento('mm_busqueda_texto', { texto: texto, resultados: literales.length }); }
      return;
    }

    var f = interpretar(texto);
    if (!f.entendido) { bloque.classList.remove('mm-busca--activa'); limpiar(); bloque.appendChild(el('p', 'mm-busca__guia', 'Puedes decirnos el tipo (corona, lágrima, manto, cruz), el color y tu presupuesto, o escribir el nombre o código de un producto. Ej.: "corona blanca hasta S/ 300" o "MEM300".')); return; }

    bloque.classList.add('mm-busca--activa');
    limpiar();
    var ent = el('div', 'mm-busca__chips');
    ent.appendChild(el('span', 'mm-busca__guia', 'Entendí:'));
    etiquetas(f).forEach(function (e) {
      var c = el('span', 'mm-busca__chip mm-busca__ent'); c.appendChild(document.createTextNode(e.t));
      var x = el('b', null, '×'); x.setAttribute('role', 'button'); x.setAttribute('aria-label', 'Quitar ' + e.t);
      x.addEventListener('click', function () { descartados[e.k] = true; pintar(); });
      c.appendChild(x); ent.appendChild(c);
    });
    bloque.appendChild(ent);

    var lista = filtrar(f), aviso = '', usados = lista;
    if (!lista.length) {
      var g = JSON.parse(JSON.stringify(f)); var pasos = [
        function () { g.urgente = false; return 'entrega en 3 horas'; },
        function () { g.min = null; g.max = null; return 'presupuesto'; },
        function () { g.colores = []; return 'color'; }
      ];
      for (var i = 0; i < pasos.length && !usados.length; i++) {
        var quitado = pasos[i]();
        var alt = filtrar(g);
        if (alt.length) {
          usados = alt;
          if (quitado === 'presupuesto') {
            alt.sort(function (a, b) { return a.precio - b.precio; });
            aviso = 'No encontramos ' + descripcion(f) + (f.max != null ? ' hasta ' + soles(f.max) : '') + '. Lo más cercano es desde ' + soles(alt[0].precio) + ':';
          } else if (quitado === 'color') aviso = 'No encontramos ' + descripcion(f) + ' con ese color y presupuesto. Mira estas opciones:';
          else aviso = 'Ahora mismo no encontramos esa opción con entrega en 3 horas. Mira estas otras:';
        }
      }
      if (!usados.length) { bloque.appendChild(el('p', 'mm-busca__estado', 'No encontramos opciones con esos datos. Prueba con menos filtros, o escribe el nombre o código del producto.')); return; }
    }
    bloque.appendChild(el('p', 'mm-busca__estado', aviso || (usados.length + (usados.length === 1 ? ' opción' : ' opciones'))));
    mostrarResultados(usados);

    var clave = etiquetas(f).map(function (e) { return e.t; }).join('|') + '|' + usados.length;
    if (clave !== ultimoEvento) {
      ultimoEvento = clave;
      evento('mm_busqueda', { tipo: f.tipos.map(function (t) { return t.id; }).join(','), color: f.colores.join(','), presupuesto_max: f.max, presupuesto_min: f.min, urgente: f.urgente, resultados: usados.length });
    }
  }

  function programar() { clearTimeout(temporizador); temporizador = setTimeout(function () { mostrarTodos = false; pintar(); }, 200); }

  /* ---------- animación de ejemplo (como si alguien escribiera) ---------- */
  function animarPlaceholder() {
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, pos = 0, borrando = false;
    function visible() { var p = document.querySelector('[data-search-popup]'); return p && getComputedStyle(p).visibility !== 'hidden'; }
    function paso() {
      if (campo.value) { campo.placeholder = 'Escribe lo que buscas…'; return setTimeout(paso, 700); }
      if (!visible()) return setTimeout(paso, 900);
      var frase = FRASES[i];
      if (reducido) { campo.placeholder = frase; i = (i + 1) % FRASES.length; return setTimeout(paso, 3200); }
      if (!borrando) {
        pos++; campo.placeholder = frase.slice(0, pos) + '▍';
        if (pos >= frase.length) { borrando = true; return setTimeout(paso, 1800); }
        return setTimeout(paso, 55);
      }
      pos -= 2; if (pos <= 0) { pos = 0; borrando = false; i = (i + 1) % FRASES.length; campo.placeholder = '▍'; return setTimeout(paso, 350); }
      campo.placeholder = frase.slice(0, pos) + '▍';
      return setTimeout(paso, 22);
    }
    paso();
  }

  function iniciar() {
    var form = document.getElementById('m-form-search');
    campo = document.querySelector('[data-search-popup] [data-search-input]');
    if (!form || !campo) return;
    estilos();
    bloque = el('div', 'mm-busca'); bloque.setAttribute('data-mm-busca', ''); bloque.setAttribute('aria-live', 'polite');
    form.parentNode.insertBefore(bloque, form.nextSibling);
    pintarVacio();
    campo.addEventListener('input', programar);
    campo.addEventListener('focus', function () { cargar().then(pintar); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-open-search-popup]')) cargar().then(pintar); });
    form.addEventListener('submit', function (e) {
      var texto = campo.value.trim();
      if (!texto || !datos) return;
      var hayLiteral = buscarLiteral(norm(texto)).length > 0;
      var f = interpretar(texto);
      if (hayLiteral || f.entendido) { e.preventDefault(); pintar(); }
    });
    animarPlaceholder();
  }

  window.MMBusqueda = { interpretar: interpretar };
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();
